var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGleapLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "109px",
    height: "111px",
    viewBox: "0 0 109 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gleap-Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gleap-Logo",
    transform: "translate(0.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7188,27.8127 C17.6053,35.359 14.9314,45.4894 14.9315,55.1925 C14.9316,64.8957 17.6055,75.0261 23.7189,82.5724 C29.6189,89.8551 39.3343,95.5076 55.2471,95.5076 C72.0242,95.5076 80.3782,88.1201 84.772,81.0962 C87.8633,76.1546 88.9708,72.543 89.3676,70.1101 C89.633,68.4823 90.926,67.1378 92.5753,67.1378 L101.534,67.1378 C103.184,67.1378 104.54,68.4752 104.399,70.1184 C104.029,74.4422 102.6,80.7522 97.4308,89.0149 C90.5125,100.075 77.5447,110.439 55.2471,110.439 C35.3238,110.439 21.1486,103.12 12.1169,91.9715 C3.29881,81.0867 0,67.3267 0,55.1926 C0,43.0584 3.29864,29.2984 12.1168,18.4136 C20.6901,7.83106999 33.8981,0.698859995 52.2577,0.0020990948 C53.9058,-0.0604476052 55.2471,1.28299999 55.2471,2.93228999 L55.2471,11.8912 C55.2471,13.5405 53.9085,14.869 52.261,14.9462 C38.1036,15.6093 29.2404,20.9971 23.7188,27.8127 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,37.2747 C109,43.8719 103.652,49.2199 97.0548,49.2199 C90.4577,49.2199 85.1096,43.8719 85.1096,37.2747 C85.1096,30.6776 90.4577,25.3295 97.0548,25.3295 C103.652,25.3295 109,30.6776 109,37.2747 Z",
    id: "Path",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGleapLogo);
export default __webpack_public_path__ + "static/media/GleapLogo.24047efa5a293a37ba0838e5026cd402.svg";
export { ForwardRef as ReactComponent };